import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Protected route that requires authentication
export const RequireAuth = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F7]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#2E7D32] border-t-transparent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

// Protected route for HUURDERS only (renters/seekers)
export const RequireHuurder = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F7]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#2E7D32] border-t-transparent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is a verhuurder, redirect to their dashboard
  if (user?.userType === 'verhuurder') {
    return <Navigate to="/verhuurder/dashboard" replace />;
  }

  return children;
};

// Protected route for VERHUURDERS only (landlords)
export const RequireVerhuurder = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F7]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#2E7D32] border-t-transparent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is a huurder, redirect to their dashboard
  if (user?.userType !== 'verhuurder') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireAuth;
